// extracted by css-extract-rspack-plugin
export default {"modeTabs":"src-modules-desktop-components-LogViewer-components-LogModeTabs-module__modeTabs-OnRLBk","modeTab":"src-modules-desktop-components-LogViewer-components-LogModeTabs-module__modeTab-QdpoEf","modeTabActive":"src-modules-desktop-components-LogViewer-components-LogModeTabs-module__modeTabActive-CVBj_k"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"modeTabs\":\"src-modules-desktop-components-LogViewer-components-LogModeTabs-module__modeTabs-OnRLBk\",\"modeTab\":\"src-modules-desktop-components-LogViewer-components-LogModeTabs-module__modeTab-QdpoEf\",\"modeTabActive\":\"src-modules-desktop-components-LogViewer-components-LogModeTabs-module__modeTabActive-CVBj_k\"}";
        // 1793872695273
        var cssReload = require("../../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  